/**
 * Social Listening View
 */
export default () => ({
  path : '/social',
  title: 'Social',

  getComponent(nextState, cb) {
    require.ensure(
      [],
      (require) => {
        const Social = require('./containers/SocialContainer').default
        cb(null, {
          content: Social,
        })
      },
      'social',
    )
  },
})



// WEBPACK FOOTER //
// ./src/routes/SocialListening/index.js